var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    { class: _vm.$style.dialog, on: { cancel: _vm.$formCancelHandler } },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _c("div", [_vm._v(_vm._s(_vm.title))]),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          class: _vm.$style.body,
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c(
            "div",
            { class: _vm.$style.group },
            [
              _c(
                "rb-input",
                {
                  attrs: {
                    "for-id": "firstName",
                    error: _vm.$showError("firstName"),
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("First Name*"),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.firstName,
                        expression: "data.firstName",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    staticClass: "rbInput",
                    attrs: {
                      id: "firstName",
                      name: "firstName",
                      "data-vv-as": "First Name",
                      placeholder: "First Name",
                      autofocus: "",
                    },
                    domProps: { value: _vm.data.firstName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.data, "firstName", $event.target.value)
                      },
                    },
                  }),
                ]
              ),
              _c(
                "rb-input",
                {
                  attrs: {
                    "for-id": "lastName",
                    error: _vm.$showError("lastName"),
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Last Name*"),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.lastName,
                        expression: "data.lastName",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    staticClass: "rbInput",
                    attrs: {
                      id: "name",
                      name: "lastName",
                      "data-vv-as": "Last Name",
                      placeholder: "Last Name",
                    },
                    domProps: { value: _vm.data.lastName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.data, "lastName", $event.target.value)
                      },
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { class: _vm.$style.group },
            [
              _c(
                "rb-input",
                {
                  attrs: { "for-id": "title", error: _vm.$showError("title") },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Title"),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.title,
                        expression: "data.title",
                      },
                    ],
                    staticClass: "rbInput",
                    attrs: {
                      id: "title",
                      name: "title",
                      "data-vv-as": "Title",
                    },
                    domProps: { value: _vm.data.title },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.data, "title", $event.target.value)
                      },
                    },
                  }),
                ]
              ),
              _c(
                "rb-input",
                { attrs: { "for-id": "type", error: _vm.$showError("type") } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("User Type"),
                  ]),
                  _c("rb-select-new", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    staticClass: "simple",
                    attrs: {
                      id: "industry",
                      options: _vm.types,
                      name: "type",
                      "data-vv-as": "User Type",
                      placeholder: "Select...",
                    },
                    model: {
                      value: _vm.data.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "type", $$v)
                      },
                      expression: "data.type",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "rb-input",
            { attrs: { "for-id": "email", error: _vm.$showError("email") } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Email Address"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.emailAddress,
                    expression: "data.emailAddress",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'",
                  },
                ],
                staticClass: "rbInput",
                attrs: {
                  id: "email",
                  name: "email",
                  "data-vv-as": "Email Address",
                },
                domProps: { value: _vm.data.emailAddress },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.data, "emailAddress", $event.target.value)
                  },
                },
              }),
            ]
          ),
          _c(
            "rb-input",
            { attrs: { "for-id": "phone", error: _vm.$showError("phone") } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Phone Number"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.phone,
                    expression: "data.phone",
                  },
                ],
                staticClass: "rbInput",
                attrs: { id: "phone", name: "phone" },
                domProps: { value: _vm.data.phone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.data, "phone", $event.target.value)
                  },
                },
              }),
            ]
          ),
          !_vm.user.id && !_vm.isCompany
            ? [
                _c("div", { staticClass: "rbInputContainer" }, [
                  _c(
                    "div",
                    {
                      staticClass: "rbInputLabel",
                      class: _vm.$style.companiesHeader,
                    },
                    [_c("span", [_vm._v("Assign Companies To User")])]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "rbInput",
                      class: _vm.$style.addCompany,
                      on: {
                        click: function ($event) {
                          _vm.addingCompanies = !_vm.addingCompanies
                        },
                      },
                    },
                    [
                      _c("span", { class: _vm.$style.selectedCompaniesNames }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.selectedCompaniesNames || "Select Accounts..."
                            ) +
                            " "
                        ),
                      ]),
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("arrow_drop_down"),
                      ]),
                    ]
                  ),
                ]),
                _vm.addingCompanies
                  ? _c(
                      "div",
                      { class: _vm.$style.companies },
                      _vm._l(_vm.companies, function (account) {
                        return _c(
                          "div",
                          {
                            key: account.id,
                            class: _vm.$style.company,
                            on: {
                              click: function ($event) {
                                return _vm.toggle(account)
                              },
                            },
                          },
                          [
                            _c("check-box", {
                              attrs: {
                                value: _vm.added(account.id),
                                "check-box-value": true,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.toggle(account)
                                },
                                click: function ($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                },
                              },
                            }),
                            _c("div", { class: _vm.$style.name }, [
                              _vm._v(" " + _vm._s(account.name) + " "),
                            ]),
                            account.primaryAgent.userDetails
                              ? _c("div", { class: _vm.$style.primary }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        account.primaryAgent.userDetails
                                          .fullName
                                      ) +
                                      " "
                                  ),
                                ])
                              : _c("div", { class: _vm.$style.unAssigned }, [
                                  _vm._v(" Not Assigned "),
                                ]),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButton mainButton",
              attrs: { type: "button" },
              on: { click: _vm.save },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
              !_vm.user.id
                ? [_vm._v(" Create New User ")]
                : [_vm._v(" Save User ")],
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }